// import React, { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import { ntxAPI } from '../../API/axiosNeatex';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { GetPrintTemplateByType } from '@store/NTX/PrintTemplate/PrintTemplateSlice';
// import NtxCustomModal from '../Modal/NtxCustomModal';

// type Props = {
//   PrintTemplateTypeId: string;
//   ReferenceId: string;
// };

// const ButtonPrint = ({ PrintTemplateTypeId, ReferenceId }: Props) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   // State for modal visibility, PDF URL, loading status, and errors
//   const [pdfUrl, setPdfUrl] = useState<string | null>(null);
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);

//   useEffect(() => {
//     dispatch(GetPrintTemplateByType(PrintTemplateTypeId));
//   }, [PrintTemplateTypeId, dispatch]);

//   const { PrintTemplateByType: data } = useAppSelector(state => state.PrintTemplate);

//   const handlePrint = async (TemplateId: string, parameterList: any[]) => {
//     setLoading(true); // Start loading
//     setError(null); // Reset error
//     setModalOpen(true); // Open modal

//     try {
//       const response = await ntxAPI.post(
//         'Reports/Print',
//         {
//           id: TemplateId,
//           parameterList: [
//             {
//               id: parameterList[0].id,
//               value: ReferenceId
//             }
//           ]
//         },
//         {
//           responseType: 'blob'
//         }
//       );

//       const blob = new Blob([response.data], {
//         type: 'application/pdf' // Adjust MIME type for PDF
//       });

//       const url = window.URL.createObjectURL(blob);
//       setPdfUrl(url); // Store the PDF URL
//     } catch (err) {
//       setError(t('حدث خطأ أثناء تحميل الملف.')); // Set error message
//       console.error('Error generating file:', err);
//     } finally {
//       setLoading(false); // Stop loading
//     }
//   };

//   return (
//     <>
//       {/* Dropdown button - تحسين باستخدام Bootstrap فقط */}
//       <div className='btn-group shadow-sm' role='group' style={{ direction: 'ltr' }}>
//         <button
//           type='button'
//           className='btn btn-theme d-flex align-items-center gap-2 rounded-start-3 rounded-end-0 border-0'
//           data-bs-toggle='dropdown'
//           aria-expanded='false'
//         >
//           <i className='bi bi-printer-fill fs-5'></i>
//           <span className='fw-semibold'>{t('Print')}</span>
//           <i className='bi bi-chevron-down ms-1'></i>
//         </button>

//         <ul
//           className='dropdown-menu dropdown-menu-start shadow-lg border-0 rounded-1 p-2'
//           style={{
//             zIndex: '1050',
//             minWidth: '220px'
//           }}
//         >
//           {data?.map(m => (
//             <li key={m.id}>
//               <Link
//                 className='dropdown-item d-flex align-items-center justify-content-between rounded-2 px-3 py-2 mb-1'
//                 to=''
//                 onClick={() => handlePrint(m.id, m.parameterList)}
//               >
//                 <div className='d-flex align-items-center gap-3'>
//                   <div className='bg-theme bg-opacity-10 p-2 rounded-2'>
//                     <i className={`${m.icon ? m.icon : 'bi bi-printer'} text-theme fs-5`}></i>
//                   </div>
//                   <div className='d-flex flex-column'>
//                     <span className='fw-medium'>{i18n.language === 'en' ? m.name : m.name2}</span>
//                     <small className='text-muted'>PDF Document</small>
//                   </div>
//                 </div>
//                 <i className='bi bi-arrow-right-short text-muted'></i>
//               </Link>
//             </li>
//           ))}

//           {/* Separator */}
//           {/* <li><hr className='dropdown-divider mx-3 my-2' /></li> */}

//           {/* إضافة خيار لجميع القوالب */}
//           {/* <li>
//             <Link className='dropdown-item text-center text-primary fw-medium py-2' to=''>
//               <i className='bi bi-collection me-2'></i>
//               {t('View All Templates')}
//             </Link>
//           </li> */}
//         </ul>
//       </div>

//       {/* Modal */}
//       <NtxCustomModal
//         width='98%'
//         show={isModalOpen}
//         setShow={setModalOpen}
//         showHeader={false}
//         centered={true}
//         bodyClassName='p-0'
//       >
//         <div style={{ height: '90vh', paddingBottom: 3 }} className='border border-1 border-theme '>
//           {/* Loading State */}
//           {loading && (
//             <div
//               className='d-flex  flex-column justify-content-center align-items-center'
//               style={{
//                 margin: 0,
//                 height: 'calc(100% - 49px)'
//               }}
//             >
//               <div className='spinner-grow text-theme' role='status'>
//                 <span className='visually-hidden'>{t('تحميل')}</span>
//               </div>
//               <div>جاري تحميل المستند</div>
//             </div>
//           )}

//           {/* Error State */}
//           {!loading && error && (
//             <div
//               className='d-flex justify-content-center align-items-center text-danger'
//               style={{
//                 margin: 0,
//                 height: 'calc(100% - 49px)'
//               }}
//             >
//               <p>{error}</p>
//             </div>
//           )}

//           {/* PDF Viewer */}
//           {!loading && !error && pdfUrl && (
//             <iframe
//               src={pdfUrl}
//               width='100%'
//               height='100%'
//               title='PDF Preview'
//               style={{
//                 margin: 0,
//                 height: 'calc(100% - 50px)',
//                 // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.4)', // الظل
//                 boxShadow: '0 1px 10px var(--bs-theme)',
//                 border: '1px solid #ccc' // خط خارجي اختياري
//                 // borderRadius: '8px', // زوايا مستديرة اختيارية
//               }}
//             ></iframe>
//           )}

//           {/* Modal Footer */}
//           <div className='text-center'>
//             <button
//               className='btn btn-lg btn-theme w-25 rounded-0'
//               onClick={() => {
//                 setModalOpen(false);
//                 setPdfUrl(null); // Reset PDF URL
//                 setError(null); // Reset error
//               }}
//             >
//               {t('إلغاء')}
//             </button>
//           </div>
//         </div>
//       </NtxCustomModal>
//     </>
//   );
// };

// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;
// export default ButtonPrint;

// import { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { ntxAPI } from '../../API/axiosNeatex';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { GetPrintTemplateByType } from '@store/NTX/PrintTemplate/PrintTemplateSlice';
// import NtxCustomModal from '../Modal/NtxCustomModal';

// type Props = {
//   PrintTemplateTypeId: string;
//   ReferenceId: string;
// };

// type FileType = 'pdf' | 'excel';

// const ButtonPrint = ({ PrintTemplateTypeId, ReferenceId }: Props) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   // State for modal visibility, PDF URL, loading status, and errors
//   const [pdfUrl, setPdfUrl] = useState<string | null>(null);
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);

//   // console.log(pdfUrl);

//   useEffect(() => {
//     dispatch(GetPrintTemplateByType(PrintTemplateTypeId));
//   }, [PrintTemplateTypeId, dispatch]);

//   const { PrintTemplateByType: data } = useAppSelector(state => state.PrintTemplate);

//   const handleFile = async (TemplateId: string, parameterList: any[], type: FileType) => {
//     if (type === 'pdf') {
//       setLoading(true);
//       setError(null);
//       setModalOpen(true);
//     }

//     try {
//       const response = await ntxAPI.post(
//         'Reports/Print',
//         {
//           id: TemplateId,
//           parameterList: [
//             {
//               id: parameterList[0].id,
//               value: ReferenceId
//             }
//           ],
//           isExcel: type === 'excel'
//         },
//         {
//           responseType: 'blob'
//         }
//       );
// // debugger
//       const mimeType =
//         type === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

//       const blob = new Blob([response.data], { type: mimeType });

//       if (type === 'pdf') {
//         const url = window.URL.createObjectURL(blob);
//         setPdfUrl(url);
//       } else {
//         // For Excel: download immediately
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement('a');
//         link.href = url;
//         link.download = `report.xlsx`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//       }
//     } catch (err) {
//       const errorMessage = type === 'pdf' ? t('حدث خطأ أثناء تحميل الملف.') : t('حدث خطأ أثناء تصدير ملف Excel.');
//       setError(errorMessage);
//       console.error('Error generating file:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {/* Dropdown button */}
//       <div className='btn-group shadow-sm' role='group' style={{ direction: 'ltr' }}>
//         <button
//           type='button'
//           className='btn btn-theme d-flex align-items-center gap-2 rounded-start-3 rounded-end-0 border-0'
//           data-bs-toggle='dropdown'
//           aria-expanded='false'
//         >
//           <i className='bi bi-printer-fill fs-5'></i>
//           <span className='fw-semibold'>{t('Print')}</span>
//           <i className='bi bi-chevron-down ms-1'></i>
//         </button>

//         <ul
//           className='dropdown-menu dropdown-menu-start shadow-lg border-0 rounded-1 p-2'
//           style={{
//             zIndex: '1050',
//             minWidth: '280px'
//           }}
//         >
//           {data?.map(m => (
//             <li key={m.id}>
//               <div
//                 className='dropdown-item d-flex align-items-center justify-content-between rounded-2 px-3 py-2 mb-1'
//                 dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
//               >
//                 <div className='d-flex align-items-center '>
//                   <i className={`${m.icon ? m.icon : 'bi bi-file-text'} text-theme `}></i>
//                   <div className='d-flex flex-column'>
//                     <span className='fw-medium'>{i18n.language === 'en' ? m.name : m.name2}</span>
//                   </div>
//                 </div>
//                 <div className='d-flex gap-2'>
//                   <button
//                     className='btn btn-outline-danger  '
//                     onClick={() => handleFile(m.id, m.parameterList, 'pdf')}
//                     title='PDF'
//                   >
//                     <i className='bi bi-file-earmark-pdf fa-lg'></i>
//                   </button>
//                   <button
//                     className='btn btn-outline-success   '
//                     onClick={() => handleFile(m.id, m.parameterList, 'excel')}
//                     title='Excel'
//                   >
//                     <i className='bi bi-file-earmark-excel fa-lg'></i>
//                   </button>
//                 </div>
//               </div>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Modal for PDF only */}
//       <NtxCustomModal
//         width='98%'
//         show={isModalOpen}
//         setShow={setModalOpen}
//         showHeader={false}
//         centered={true}
//         bodyClassName='p-0'
//       >
//         <div style={{ height: '90vh', paddingBottom: 3 }} className='border border-1 border-theme '>
//           {/* Loading State */}
//           {loading && (
//             <div
//               className='d-flex flex-column justify-content-center align-items-center'
//               style={{
//                 margin: 0,
//                 height: 'calc(100% - 49px)'
//               }}
//             >
//               <div className='spinner-grow text-theme' role='status'>
//                 <span className='visually-hidden'>{t('تحميل')}</span>
//               </div>
//               <div>جاري تحميل المستند</div>
//             </div>
//           )}

//           {/* Error State */}
//           {!loading && error && (
//             <div
//               className='d-flex justify-content-center align-items-center text-danger'
//               style={{
//                 margin: 0,
//                 height: 'calc(100% - 49px)'
//               }}
//             >
//               <p>{error}</p>
//             </div>
//           )}

//           {/* PDF Viewer */}
//           {!loading && !error && pdfUrl && (
//             <iframe
//               src={pdfUrl}
//               width='100%'
//               height='100%'
//               title='PDF Preview'
//               style={{
//                 margin: 0,
//                 height: 'calc(100% - 50px)',
//                 boxShadow: '0 1px 10px var(--bs-theme)',
//                 border: '1px solid #ccc'
//               }}
//             ></iframe>
//           )}

//           {/* Modal Footer */}
//           <div className='text-center'>
//             <button
//               className='btn btn-lg btn-theme w-25 rounded-0'
//               onClick={() => {
//                 setModalOpen(false);
//                 setPdfUrl(null);
//                 setError(null);
//               }}
//             >
//               {t('إلغاء')}
//             </button>
//           </div>
//         </div>
//       </NtxCustomModal>
//     </>
//   );
// };

// export default ButtonPrint;

import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ntxAPI } from '../../API/axiosNeatex';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { GetPrintTemplateByType } from '@store/NTX/PrintTemplate/PrintTemplateSlice';
import NtxCustomModal from '../Modal/NtxCustomModal';
import NeatixModal from '@components/Modal/NeatixModal';
import { Card, CardBody } from '@components/card/card';
import Loading from '@components/Shared/Loader/Loading';

type Props = {
  PrintTemplateTypeId: string;
  ReferenceId: string;
};

type FileType = 'pdf' | 'excel';

type NoticeVariant = 'loading' | 'info' | 'error';

type NoticeState = null | {
  variant: NoticeVariant;
  title: string;
  message?: string;
  fileName?: string;
};

const ButtonPrint = ({ PrintTemplateTypeId, ReferenceId }: Props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  // ✅ PDF Viewer (Large)
  const [viewerOpen, setViewerOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  // ✅ Notice Modal (Small)
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [notice, setNotice] = useState<NoticeState>(null);

  const requestSeq = useRef(0);

  useEffect(() => {
    dispatch(GetPrintTemplateByType(PrintTemplateTypeId));
  }, [PrintTemplateTypeId, dispatch]);

  const { PrintTemplateByType: data } = useAppSelector(state => state.PrintTemplate);

  // ✅ تنظيف PDF ObjectURL
  useEffect(() => {
    return () => {
      if (pdfUrl) window.URL.revokeObjectURL(pdfUrl);
    };
  }, [pdfUrl]);

  const getFileNameFromContentDisposition = (cd?: string, fallback = 'report') => {
    if (!cd) return fallback;
    const match = /filename\*?=(?:UTF-8'')?("?)([^";]+)\1/i.exec(cd);
    const fileName = match?.[2];
    try {
      return fileName ? decodeURIComponent(fileName) : fallback;
    } catch {
      return fileName ?? fallback;
    }
  };

  const detectIsPdfByMagicBytes = async (blob: Blob) => {
    // PDF يبدأ غالبًا بـ %PDF-
    const buf = await blob.slice(0, 5).arrayBuffer();
    const bytes = new Uint8Array(buf);
    const header = String.fromCharCode(...bytes);
    return header === '%PDF-';
  };

  const downloadBlob = (blob: Blob, fileName: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const openNotice = (payload: NoticeState) => {
    setNotice(payload);
    setNoticeOpen(true);
  };

  const closeNotice = () => {
    setNoticeOpen(false);
    setNotice(null);
  };

  const closeViewer = () => {
    setViewerOpen(false);
    if (pdfUrl) window.URL.revokeObjectURL(pdfUrl);
    setPdfUrl(null);
  };

  // const NoticeContent = ({ n }: { n: Exclude<NoticeState, null> }) => {
  //   const isRtl = i18n.language === 'ar';
  //   const icon =
  //     n.variant === 'loading'
  //       ? 'bi bi-hourglass-split'
  //       : n.variant === 'error'
  //         ? 'bi bi-exclamation-triangle-fill'
  //         : 'bi bi-file-earmark-word-fill';

  //   const badgeText = n.variant === 'loading' ? t('تحميل') : n.variant === 'error' ? t('خطأ') : t('معلومة');

  //   const badgeClass =
  //     n.variant === 'loading' ? 'bg-light text-muted border' : n.variant === 'error' ? 'bg-danger' : 'bg-info';

  //   return (
  //     <Card>
  //       <CardBody>
  //         <div dir={isRtl ? 'rtl' : 'ltr'} className='p-3'>
  //           <div className='d-flex align-items-start gap-3'>
  //             <div
  //               className='rounded-circle d-flex align-items-center justify-content-center flex-shrink-0'
  //               style={{ width: 54, height: 54, background: 'rgba(0,0,0,0.06)' }}
  //             >
  //               {n.variant === 'loading' ? (
  //                 <div className='spinner-border text-theme' role='status' aria-label='loading'></div>
  //               ) : (
  //                 <i className={`${icon} fs-3 ${n.variant === 'error' ? 'text-danger' : 'text-theme'}`}></i>
  //               )}
  //             </div>

  //             <div className='flex-grow-1'>
  //               <div className='d-flex align-items-center justify-content-between gap-2'>
  //                 <div className='fw-bold' style={{ fontSize: 15 }}>
  //                   {n.title}
  //                 </div>
  //                 <span className={`badge rounded-pill ${badgeClass}`}>{badgeText}</span>
  //               </div>

  //               <div className='small text-muted mt-1'>{n.message}</div>

  //               {n.fileName && (
  //                 <div className='mt-3 d-flex align-items-center gap-2 p-2 rounded-3 border bg-light'>
  //                   <i className='bi bi-paperclip text-muted'></i>
  //                   <span className='small fw-semibold text-break'>{n.fileName}</span>
  //                 </div>
  //               )}

  //               <div className='mt-3 d-flex justify-content-end gap-2'>
  //                 <button
  //                   type='button'
  //                   className='btn btn-outline-secondary rounded-3 px-3'
  //                   onClick={closeNotice}
  //                   disabled={n.variant === 'loading'} // ✅ أثناء التحميل لا نخليه يقفل (اختياري)
  //                 >
  //                   <i className='bi bi-x-lg me-2'></i>
  //                   {t('إغلاق')}
  //                 </button>

  //                 {n.variant !== 'loading' && (
  //                   <button type='button' className='btn btn-theme rounded-3 px-3' onClick={closeNotice}>
  //                     <i className='bi bi-check2 me-2'></i>
  //                     {t('حسنًا')}
  //                   </button>
  //                 )}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </CardBody>
  //     </Card>
  //   );
  // };

  const handleFile = async (TemplateId: string, parameterList: any[], type: FileType) => {
    const seq = ++requestSeq.current;

    // ✅ تنظيف سابق
    if (pdfUrl) window.URL.revokeObjectURL(pdfUrl);
    setPdfUrl(null);
    setViewerOpen(false);

    // Excel: لا نحتاج مودال
    if (type === 'excel') {
      try {
        const response = await ntxAPI.post(
          'Reports/Print',
          {
            id: TemplateId,
            parameterList: [{ id: parameterList?.[0]?.id, value: ReferenceId }],
            isExcel: true
          },
          { responseType: 'blob' }
        );

        const contentDisposition: string | undefined = response.headers?.['content-disposition'];
        const serverName = getFileNameFromContentDisposition(contentDisposition, 'report.xlsx');
        const name = serverName.toLowerCase().endsWith('.xlsx') ? serverName : 'report.xlsx';

        const receivedBlob: Blob = response.data instanceof Blob ? response.data : new Blob([response.data]);
        downloadBlob(receivedBlob, name);
      } catch (err) {
        openNotice({
          variant: 'error',
          title: t('تعذر تصدير Excel'),
          message: t('حدث خطأ أثناء تصدير ملف Excel.')
        });
      }
      return;
    }

    // ✅ PDF button: افتح مودال صغير "تحميل"
    openNotice({
      variant: 'loading',
      title: t('جاري تجهيز المستند'),
      message: t('يرجى الانتظار، يتم إنشاء الملف...')
    });

    try {
      const response = await ntxAPI.post(
        'Reports/Print',
        {
          id: TemplateId,
          parameterList: [{ id: parameterList?.[0]?.id, value: ReferenceId }],
          isExcel: false
        },
        { responseType: 'blob' }
      );

      // لو جاء رد قديم تجاهله
      if (seq !== requestSeq.current) return;

      const contentType: string = response.headers?.['content-type'] || '';
      const contentDisposition: string | undefined = response.headers?.['content-disposition'];

      const receivedBlob: Blob = response.data instanceof Blob ? response.data : new Blob([response.data]);
      const serverName = getFileNameFromContentDisposition(contentDisposition, 'report.pdf');

      const looksPdfByHeader = contentType.toLowerCase().includes('application/pdf');
      const looksPdfByBytes = await detectIsPdfByMagicBytes(receivedBlob);
      const isPdf = looksPdfByHeader || looksPdfByBytes;

      if (isPdf) {
        // ✅ اغلق المودال الصغير وافتح Viewer الكبير
        closeNotice();
        const url = window.URL.createObjectURL(receivedBlob);
        setPdfUrl(url);
        setViewerOpen(true);
        return;
      }

      // ✅ Word/غيره: تنزيل + رسالة في مودال صغير
      const ct = contentType.toLowerCase();
      let forcedName = serverName;

      if (ct.includes('wordprocessingml.document')) {
        if (!forcedName.toLowerCase().endsWith('.docx')) forcedName = 'report.docx';
      } else if (ct.includes('msword')) {
        if (!forcedName.toLowerCase().endsWith('.doc')) forcedName = 'report.doc';
      } else {
        if (!/\.(pdf|docx|doc|xlsx)$/i.test(forcedName)) forcedName = 'report.docx';
      }

      downloadBlob(receivedBlob, forcedName);

      openNotice({
        variant: 'info',
        title: t('تم تنزيل المستند'),
        // message: t('الملف المُرسل ليس PDF، لذلك تم تنزيله تلقائيًا بدل عرضه داخل النظام.'),
        // message: t('تم ا تنزي '),
        fileName: forcedName
      });
    } catch (err) {
      if (seq !== requestSeq.current) return;

      openNotice({
        variant: 'error',
        title: t('تعذر تحميل المستند'),
        message: t('حدث خطأ أثناء تحميل الملف.')
      });
    }
  };

  const NoticeContent = ({ n }: { n: Exclude<NoticeState, null> }) => {
    const isRtl = i18n.language === 'ar';

    // تعريف الأيقونات والنصوص بناءً على النوع
    const variantConfig = {
      loading: {
        icon: 'bi-hourglass-split',
        badgeText: t('تحميل'),
        badgeClass: 'bg-light text-muted border',
        iconClass: 'text-theme',
        iconElement: <div className='spinner-border text-theme' role='status' aria-label='loading'></div>
      },
      error: {
        icon: 'bi-exclamation-triangle-fill',
        badgeText: t('خطأ'),
        badgeClass: 'bg-danger text-white',
        iconClass: 'text-danger',
        iconElement: <i className='bi-exclamation-triangle-fill fs-3 text-danger'></i>
      },
      info: {
        icon: 'bi-file-earmark-word-fill',
        badgeText: t('معلومة'),
        badgeClass: 'bg-info text-white',
        iconClass: 'text-theme',
        iconElement: <i className='bi-file-earmark-word-fill fs-3 text-theme'></i>
      }
    };

    const config = variantConfig[n.variant] || variantConfig.info;

    return (
      <Card
        className={`border-${n.variant === 'error' ? 'danger' : n.variant === 'loading' ? 'warning' : 'info'} border-top-0 border-end-0 border-bottom-0 border-3`}
      >
        <CardBody className='p-0'>
          <div dir={isRtl ? 'rtl' : 'ltr'} className='p-4'>
            <div className='d-flex align-items-start gap-3'>
              {/* أيقونة الحالة */}
              <div className='position-relative'>
                <div
                  className='  d-flex align-items-center justify-content-center flex-shrink-0'
                  style={{
                    width: 60,
                    height: 60
                  }}
                >
                  {n.variant === 'loading' ? config.iconElement : config.iconElement}
                </div>
              </div>

              {/* محتوى الإشعار */}
              <div className='flex-grow-1'>
                {/* العنوان والبادج في سطر واحد */}
                <div className='d-flex align-items-center justify-content-between mb-2'>
                  <h6 className='fw-bold mb-0' style={{ fontSize: '1.05rem' }}>
                    {n.title}
                  </h6>
                </div>

                {/* رسالة الإشعار */}
                <p className='text-muted mb-3' style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>
                  {n.message}
                </p>

                {/* معلومات الملف المرفق */}
                {n.fileName && (
                  <div className='alert alert-info border d-flex align-items-center gap-3 p-3 mb-3'>
                    <div
                      className='  rounded-circle d-flex align-items-center justify-content-center'
                      style={{ width: 40, height: 40 }}
                    >
                      <i className='bi-paperclip text-muted'></i>
                    </div>
                    <div className='flex-grow-1'>
                      <div className='small text-muted mb-1'>{t('الملف المرفق')}</div>
                      <div className='fw-semibold text-break'>{n.fileName}</div>
                    </div>
                    <i className='bi-download text-muted' style={{ fontSize: '1.2rem' }}></i>
                  </div>
                )}

                {/* أزرار الإجراءات */}
                <div className='d-flex justify-content-end gap-2 pt-3 border-top'>
                  <button
                    type='button'
                    className={`btn btn-outline-secondary   px-4 ${isRtl ? 'flex-row-reverse' : ''}`}
                    onClick={closeNotice}
                    disabled={n.variant === 'loading'}
                  >
                     {t('Cancel')}
                  </button>

                  {n.variant !== 'loading' && (
                    <button
                      type='button'
                      className={`btn btn-${n.variant === 'error' ? 'danger' : 'theme'}  px-4 ${isRtl ? 'flex-row-reverse' : ''}`}
                      onClick={closeNotice}
                    >
                       {t('Ok')}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    );
  };

  return (
    <>
      {/* Dropdown button */}
      <div className='btn-group shadow-sm' role='group' style={{ direction: 'ltr' }}>
        <button
          type='button'
          className='btn btn-theme d-flex align-items-center gap-2 rounded-start-3 rounded-end-0 border-0'
          data-bs-toggle='dropdown'
          aria-expanded='false'
        >
          <i className='bi bi-printer-fill fs-5'></i>
          <span className='fw-semibold'>{t('Print')}</span>
          <i className='bi bi-chevron-down ms-1'></i>
        </button>

        <ul
          className='dropdown-menu dropdown-menu-start shadow-lg border-0 rounded-1 p-2'
          style={{ zIndex: '1050', minWidth: '280px' }}
        >
          {data?.map(m => (
            <li key={m.id}>
              <div
                className='dropdown-item1 d-flex align-items-center justify-content-between rounded-2 p-0'
                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              >
                <div className='d-flex align-items-center'>
                  <i className={`${m.icon ? m.icon : 'bi bi-file-text'} text-theme`}></i>
                  <div className='d-flex flex-column'>
                    <span className='fw-medium'>{i18n.language === 'en' ? m.name : m.name2}</span>
                  </div>
                </div>

                <div className='d-flex gap-2'>
                  <button
                    className='btn btn-outline-danger'
                    onClick={() => handleFile(m.id, m.parameterList, 'pdf')}
                    title='PDF'
                  >
                    <i className='bi bi-file-earmark-pdf fa-lg'></i>
                  </button>

                  <button
                    className='btn btn-outline-success'
                    onClick={() => handleFile(m.id, m.parameterList, 'excel')}
                    title='Excel'
                  >
                    <i className='bi bi-file-earmark-excel fa-lg'></i>
                  </button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* ✅ Small Notice Modal */}
      <NeatixModal
        size={'md'}
        // show={noticeOpen}
        show={noticeOpen}
        setShow={(v: any) => {
          if (notice?.variant === 'loading') return;
          setNoticeOpen(v);
          if (!v) setNotice(null);
        }}
        showHeader={false}
        centered={true}
        bodyClassName='p-0'
      >
        {notice && <NoticeContent n={notice} />}
      </NeatixModal>

      {/* ✅ Large PDF Viewer Modal */}
      <NtxCustomModal
        width='98%'
        show={viewerOpen}
        setShow={(v: any) => {
          setViewerOpen(v);
          if (!v) closeViewer();
        }}
        showHeader={false}
        centered={true}
        bodyClassName='p-0'
      >
        <div style={{ height: '90vh', paddingBottom: 3 }} className='border border-1 border-theme'>
          {!pdfUrl ? (
            <div className='d-flex justify-content-center align-items-center' style={{ height: 'calc(100% - 50px)' }}>
              <div className='text-muted'>{t('لا يوجد ملف للعرض')}</div>
            </div>
          ) : (
            <iframe
              src={pdfUrl}
              width='100%'
              height='100%'
              title='PDF Preview'
              style={{
                margin: 0,
                height: 'calc(100% - 50px)',
                boxShadow: '0 1px 10px var(--bs-theme)',
                border: '1px solid #ccc'
              }}
            />
          )}

          <div className='text-center'>
            <button className='btn btn-lg btn-theme w-25 rounded-0' onClick={closeViewer}>
              {t('إغلاق')}
            </button>
          </div>
        </div>
      </NtxCustomModal>
    </>
  );
};

export default ButtonPrint;
